module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background-color": "#f6f7fb"
    }
  }, [(_vm.$route.name === 'exchangeWork') ? _c('div', {
    staticClass: "exchangeWork"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.workData.length > 10
    }
  }, _vm._l((_vm.workData), function(item) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.closeUsername)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [(item.id) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm._f("numberToMonthDate")(item.beginTime, '')))]), _vm._v(" "), _c('span', [_vm._v("~")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("numberToMonthDate")(item.endTime, '')))])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(item.turnInAmount)), (item.leaseAmount) ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("(含租赁费:"), _c('b', [_vm._v(_vm._s(item.leaseAmount) + "元")]), _vm._v(")")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      domProps: {
        "textContent": _vm._s(item.refundAmount)
      }
    }), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [(item.id) ? _c('div', {
      staticClass: "btnInline"
    }, [_c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#9FB2D7",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: ("/sys/" + _vm.curStoreId + "/exchangeWork/staffGrade"),
            query: {
              workShiftId: item.id,
              closeUsername: item.closeUsername,
              beginTime: item.beginTime,
              endTime: item.endTime
            }
          })
        }
      }
    }, [_vm._v("对账单")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#9FB2D7",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.cutSalesDetail(item)
        }
      }
    }, [_vm._v("销售明细")]), _vm._v(" "), (item.transactionEnable) ? _c('span', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#9FB2D7",
        "text-decoration": "underline"
      },
      on: {
        "click": function($event) {
          return _vm.cutStockDetail(item)
        }
      }
    }, [_vm._v("库存记录")]) : _vm._e()]) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pager flex flex-align-center"
  }, [_c('div', {
    staticClass: "pagerCon clearfix"
  }, [_c('div', {
    staticClass: "pagerBtnBox right"
  }, [_c('div', {
    staticClass: "pagerBtn"
  }, [_c('span', {
    staticClass: "prev flex flex-align-center flex-pack-center left",
    class: {
      havePage: (_vm.curPage > 0)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('span', {
    staticClass: "curPageNumber flex flex-align-center flex-pack-center left",
    domProps: {
      "textContent": _vm._s('' + (_vm.curPage + 1))
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "next flex flex-align-center flex-pack-center left",
    class: {
      havePage: ((_vm.curPage + 1) < _vm.totalPage)
    },
    on: {
      "click": function($event) {
        return _vm.changePage(true)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "curPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('第 ' + (_vm.curPage + 1) + ' / ' + _vm.totalPage + ' 页')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "totalPage flex flex-align-center right",
    domProps: {
      "textContent": _vm._s('共' + _vm.totalElements + '条')
    }
  })])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "销售明细",
      "visible": _vm.showPutAllMask1,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask1 = $event
      },
      "close": _vm.closeSaleDetail
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "couponBox right"
  }, [_c('div', {
    staticClass: "changeWorkTitle",
    staticStyle: {
      "margin-bottom": "10px",
      "font-weight": "600"
    }
  }, [_vm._v("优惠券核销统计")]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, _vm._l((_vm.salesData.coupons), function(item, ind) {
    return _c('div', [_c('div', {
      staticClass: "couponItem clearfix"
    }, [_c('span', {
      staticClass: "name left",
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "price right",
      domProps: {
        "textContent": _vm._s('￥' + item.amount / 100)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "number right",
      domProps: {
        "textContent": _vm._s('X' + item.quantity)
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "goodTypeBox left"
  }, [_c('div', {
    staticClass: "changeWorkTitle",
    staticStyle: {
      "margin-bottom": "10px",
      "font-weight": "600"
    }
  }, [_vm._v("分类列表")]), _vm._v(" "), _c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("火星网费：")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(_vm.salesData.cost.cashAmount)))])]), _vm._v(" "), _c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("会员支付网费:")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(_vm.salesData.net.amount)))]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(",数量:")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.salesData.net.qty))])]), _vm._v(" "), _c('div', {
    staticClass: "cost-cashAmount"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("会员充值金额：")]), _vm._v(" "), _c('span', {
    staticClass: "val"
  }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")((_vm.salesData.memberDepositAmount) / 100)))])]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "value": _vm.nowTypeName,
      "accordion": ""
    },
    on: {
      "change": _vm.getNowTypeProducts
    }
  }, [_vm._l((_vm.rentData), function(item, ind) {
    return _c('el-collapse-item', {
      key: 'rent' + ind,
      attrs: {
        "name": item.typeName
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("\n                                    " + _vm._s(item.typeName) + "：￥" + _vm._s(_vm._f("toFixedNum")(item.amount)) + "\n                                ")]), _vm._v(" "), _vm._l((item.leaseItemList), function(bigGood) {
      return _c('div', {
        staticClass: "goodItem clearfix"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(bigGood.qty + ' × ' + bigGood.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "right"
      }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(bigGood.amount)))])])
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.salesData.itemDetails), function(item, ind) {
    return _c('el-collapse-item', {
      key: 'big' + ind,
      attrs: {
        "name": item.typeName
      }
    }, [_c('template', {
      slot: "title"
    }, [_vm._v("\n                                    " + _vm._s(item.typeName) + "：￥" + _vm._s(_vm._f("toFixedNum")(item.amount)) + "\n                                ")]), _vm._v(" "), _vm._l((_vm.nowItem), function(bigGood) {
      return _c('div', {
        staticClass: "goodItem clearfix"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(bigGood.qty + ' × ' + bigGood.name)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "right"
      }, [_vm._v("￥" + _vm._s(_vm._f("toFixedNum")(bigGood.amount)))])])
    })], 2)
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "员工销售",
      "visible": _vm.showPutAllMask2,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showPutAllMask2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('div', [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("员工名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("订单数量")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("销售金额")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.staffArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1 + _vm.pageSize * _vm.salesCurPage)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.creatorName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.orderCount)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.totalAmount)
      }
    })])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.staff2Excel
    }
  }, [_vm._v("导出Excel")])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "stock",
    attrs: {
      "title": "库存记录",
      "visible": _vm.showStock,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showStock = $event
      }
    }
  }, [_c('div', {
    staticClass: "putAllInner"
  }, [_c('div', {
    staticClass: "putAllTableBox"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("商品名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("分类名")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("库存剩余")])])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', [_c('tbody', _vm._l((_vm.stockArr), function(item, ind) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(ind + 1)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.productName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.typeName)
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(item.qty)
      }
    })])])
  }), 0)])])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'staffGrade') ? _c('router-view') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "searchCon clearfix"
  }, [_c('div', {
    staticClass: "title_item left"
  }, [_c('i', [_vm._v("*")]), _c('span', [_vm._v("本班现金为收银员上交金额")])]), _vm._v(" "), _c('div', {
    staticClass: "title_item left"
  }, [_c('i', [_vm._v("*")]), _c('span', [_vm._v("微信和支付宝直接查阅电子对账单（公众号-'店员宝'-'我的店铺'）")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("交班员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("交接班时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("总收入")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("退单")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5d018522","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/saleInfo/exchangeWork/exchangeWork.vue
// module id = 950
// module chunks = 1